import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getClientProfitability = createAsyncThunk('Client/getClientProfitability', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Profitability/GetClientProfitability', params, {mode:'cors'})
      
    return {
         params,
         data: response.data.data,
         allData: response.data.allData,
         totalPages: response.data.total,

         totalBookings: response.data.bookings,
         invoiceBookings: response.data.invbookings,
         completedBookings: response.data.cmpbookings,
         futureBookings: response.data.ftrbookings,
         totalAmount: response.data.amount,
         invoiceAmount: response.data.invamount,
         completedAmount: response.data.cmpamount,
         profitAmount: response.data.prfamount
       }
 })
export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, {mode:'cors'})
  return response.data
})

export const getPassengerList = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList', params, {mode: 'cors'})
  return response.data
})
export const getPaymentMethodList = createAsyncThunk('appBookingValidation/getPaymentMethodList', async (params) => {
  const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
  return response.data
})

export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, { mode: 'cors' })
  return response.data
})
export const getClientList = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
  return response.data
})

export const ProfitabilitySlice = createSlice({
  name: 'profitability',
  initialState: {
    data: [],
    clientProfitability: [],
    vehicleProfitability: [],
    driverProfitability: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument:[],
    IsSaved:0,
    ProfitabilityStartDate: [],
    ProfitabilityEndDate: [],
   Profitabilityclient: [], 
   Profitabilitydriver: [],
   Profitabilitypassenger: [],
   ProfitabilityvehicleType: [], 
   ProfitabilitypaymentMethod: [],

         totalBookings: 0,
         invoiceBookings: 0,
         completedBookings: 0,
         futureBookings: 0,
         totalAmount: 0,
         invoiceAmount: 0,
         completedAmount: 0,
         profitAmount: 0
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getClientProfitability.fulfilled, (state, action) => {
        

         state.totalBookings = action.payload.totalBookings
         state.invoiceBookings = action.payload.invoiceBookings
         state.completedBookings = action.payload.completedBookings
         state.futureBookings = action.payload.futureBookings
         state.totalAmount = action.payload.totalAmount
         state.invoiceAmount = action.payload.invoiceAmount
         state.completedAmount = action.payload.completedAmount
         state.profitAmount = action.payload.profitAmount

        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.ProfitabilityStartDate = action.payload.params.startDate
        state.ProfitabilityEndDate = action.payload.params.endDate
        state.Profitabilityclient = action.payload.params.clientID
        state.Profitabilitydriver = action.payload.params.driverID
        state.Profitabilitypassenger = action.payload.params.passengerID
        state.ProfitabilityvehicleType = action.payload.params.vehicleTypeID
        state.ProfitabilitypaymentMethod = action.payload.params.paymentMethodID
      })
      // .addCase(getClientProfitabilityDate.fulfilled, (state, action) => {
      //   state.ProfitabilityDate = action.payload.params
      // })
    }
})


export default ProfitabilitySlice.reducer
